export default __webpack_public_path__ + "static/spiritual-india-places-3-eab1bd07bbcb621b70692bae8f87af66.jpg";